import socketIOClient from 'socket.io-client';
const SOCKET_END_POINT =
  process.env.NODE_ENV === 'development'
    ? 'localhost:3002'
    : 'socket.motiners.com';
const SOCKEKT_PROTOCOL = process.env.NODE_ENV === 'development' ? 'http' : 'https';
let socket = null;
const self = {
  makeConnection: () => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          let opts = {
            reconnectionDelayMax: 10000,
            withCredentials: true,
          };
          let socketEndPoint = SOCKET_END_POINT;
          socket = socketIOClient(
            `${SOCKEKT_PROTOCOL}://${socketEndPoint}`,
            opts,
          );
          resolve(true);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      })();
    });
  },
  disconnectConnection:()=>{
    //disconnect
    if(socket?.disconnect)
    {
      socket.disconnect();  
    }
  },
  joinChatRoom: (params) => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          if (params['type'] === 'group_chat') {
            let form = {};
            form['type'] = 'group_chat';
            form['group_no'] = params['group_no'];
            socket.emit('join', form, (response) => {
              if(response.success === 0)
              {
                resolve(response);
                return;
              }
              resolve(true);
            });
          }
          else if(params['type'] === 'matching_chat')
          {
            let form = {};
            form['type'] = 'matching_chat';
            form['room_no'] = params['room_no'];
            
            socket.emit('join', form, (response) => {
              if(response.success === 0)
              {
                resolve(response);
                return;
              }
              resolve(true);
            });
          }
        } catch (error) {
          console.log(error);
          reject(error);
        }
      })();
    });
  },
  setMatchingChatConnection: (params) => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          let response = null;
          //make connection
          await self.makeConnection();

          //join group
          let form = {};
          form['type'] = 'matching_chat';
          form['room_no'] = params['room_no'];
          response = await self.joinChatRoom(form);

          if(response !== true)
          {
            resolve(response);
            return;
          }
          //set groupchat receiver
          response = await self.receiveMatchingChatMsg(params);

          if(response !== true)
          {
            resolve(response);
            return;
          }

          resolve(true);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      })();
    });
  },
  sendMatchingChatMsg: (chatObj) => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          socket.emit('matching_message', chatObj, (response)=>{
            resolve(response);
          });
        } catch (error) {
          reject(error);
        }
      })();
    });
  },
  receiveMatchingChatMsg:(params) => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          socket.on('response_matching_chat', (response) => { 
            if (response.success === 0){
              resolve(response);
            }
            if(params['on_received'])
            {
              let onReceivedAction = params['on_received'];
              onReceivedAction(response.data);
            } 
            resolve(true);
          });
        } catch (error) {
          console.log(error);
          reject(error);
        }
      })();
    });
  },
  setGroupChatConnection: (params, updateChatListRedux) => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          //make connection
          await self.makeConnection();
          //join group
          let form = {};
          form['type'] = 'group_chat';
          form['group_no'] = params['group_no']; 
          await self.joinChatRoom(form); 
          //set groupchat receiver
          await self.receiveGroupChatMsg(updateChatListRedux);

          resolve(true);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      })();
    });
  },
  sendGroupChatMsg: (chatObj, updateChatListRedux) => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          socket.emit('group_message', chatObj);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      })();
    });
  },
  receiveGroupChatMsg: (updateChatListRedux) => {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          socket.on('response_group_chat', (response) => { 
            if (response.success === 0) return;
            updateChatListRedux(response.data.chat_item);
          });
          resolve(true);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      })();
    });
  },
};

export default self;
